import React from 'react'
import Resheader from '../../business-types/restaurant/modules/home/Resheader'
import Resmenu from '../../business-types/restaurant/modules/home/Resmenu'

const Reskitchen = () => {

  const oldOrders =()=>{
    
  }
  
  return (
    <div style={{ display: "flex", flexDirection: 'column',overflow:'hidden'}}>
      <Resheader Resheader={"Kitchen"}  OldOrders={oldOrders}/>
      <div style={{display:"flex"}}>
            <Resmenu Resmenu={""} />
            <h1 style={{color:"red"}}>Kitchen Is Ready, It's Time For Cooking.Waiting for bharathi</h1>
      </div>
     </div>
  )
}

export default Reskitchen

